import Vue from 'vue'
import gql from 'graphql-tag'
import { Component } from 'vue-property-decorator'

import { Contact } from '@/modules/Contact/interfaces/contact'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'

import AppDialog from '@/components/AppDialog.vue'
import { deleteContact } from '@/modules/Contact/gql/contact.gql'
import ContactForm from '@/modules/Contact/components/ContactForm.vue'

@Component({
  components: {
    ContactForm,
    AppDialog
  }
})
export default class ContactDialog extends Vue {
  targetContact: Contact | null = null

  contactDialog = {
    actionType: 'new',
    show: false,
    title: 'New Contact',
    disable: false
  }

  deleteContDialog = {
    show: false,
    title: 'Delete Contact',
    text: ''
  }
  disableConfirm = false

  showContactEditDialog (e: Event, targetContact?: Contact) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Contact'
    if (targetContact) {
      this.targetContact = targetContact
      actionType = 'edit'
      title = 'Edit Contact'
    }
    this.contactDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideContactEditDialog () {
    this.targetContact = null
    this.contactDialog = {
      actionType: 'new',
      show: false,
      title: 'New Contact',
      disable: false
    }
  }

  async deleteContact (e: Event, contact: Contact) {
    e.preventDefault()
    e.stopPropagation()
    this.targetContact = contact
    this.deleteContDialog.show = true
  }

  async deleteContactPost () {
    if (!this.targetContact) {
      return
    }
    const { id } = this.targetContact
    this.deleteContDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteContact,
        variables: {
          contactId: Number(id)
        }
      })

      const res = result.data.deleteContact
      if (res) {
        showNotification({
          msg: 'Delete contact successfully',
          type: SnackType.Success
        })
        this.targetContact = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
